import classnames from 'classnames';
import React from 'react';
import * as PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import useButtonStyles from 'Components/common/Events/useButtonStyles';
import ExplorerModal from './ExplorerModal';
import LocationTooFarInfoGraphic from './LocationTooFarInfoGraphic';

const LocationTooFarModal = props => {
    const classes = useButtonStyles();

    return (
        <ExplorerModal
            titleImage={
                <div className="location-graphic">
                    <LocationTooFarInfoGraphic
                        primaryColour="#00a0dd"
                        secondaryColour="#009edd2d"
                    />
                </div>
            }
            // array to split text as required
            title={['Location sharing limitation']}
            subTitle={`You must be within ${props.mapBoundaryRadius} ${
                props.unitOfMeasure
            } of the venue to enable location sharing`}
            buttons={
                <div className={classnames('button-spacer', 'button-container')}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.actionButton}
                        onClick={() => {
                            props.onClose();
                        }}
                        target="_blank"
                    >
                        OK
                    </Button>
                </div>
            }
            onClose={props.onClose}
            wrapperClass="white-overlay-background"
        />
    );
};

LocationTooFarModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    mapBoundaryRadius: PropTypes.number,
    unitOfMeasure: PropTypes.string,
};

export default LocationTooFarModal;
